// Section 10: a worker with a tool gets the job's tool multiplier; without one, 1.0x (noted
// `no tool`). During a season the holders are this season's allocation (decide phase); between
// seasons (explain() in the UI) they are last season's, the best forecast of the next draw.
import { defineContributor } from '../../core/registry';
import { mod } from '../../core/modifiers';
import { lastCompletedReport } from '../../core/queries';

export const toolsContributor = defineContributor({
  slot: 'tools',
  id: 'tools:core',
  targets: ['output'],
  modifiers(ctx, target) {
    if (target.kind !== 'output') return [];
    const factor = ctx.registry.jobs[target.jobId].toolFactor;
    if (factor === null) return [];
    const report = ctx.state.currentReport ?? lastCompletedReport(ctx.state);
    const hadTool = report?.toolUse[target.personId] ?? false;
    return hadTool
      ? [mod.mul('tools:tool', factor, 'tool')]
      : [mod.mul('tools:tool', 1, 'no tool')];
  },
});
